import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import type { Observable } from 'rxjs';
import { tap } from 'rxjs';
import { AuthStore } from '../../../../../auth/common/stores/auth.store';
import type { EngineConfig } from '../interfaces/engine-config';
import { EngineConfigService } from '../services/engine-config.service';

export const engineConfigResolver: ResolveFn<Observable<EngineConfig>> = () => {
  const authStore = inject(AuthStore);
  const engineConfigService = inject(EngineConfigService);

  return engineConfigService
    .getGlobalEngineConfig()
    .pipe(tap((engineConfig) => authStore.setEngineConfig(engineConfig)));
};
